<template>
	<div v-if="remainingSelectors.length === 0 && !product.isSoldOut && productHasStock" id="quantityExceptionMessaging">
		<div v-show="showOnlyAvailableMessage && !quantityExceptionMessage" class="user-hint">
			<span class="red-text" v-if="maxBuyableQty > 0">
				<i class="fa fa-exclamation-triangle"></i>
				Only {{ maxBuyableQty }} available
				<span style="font-weight:500;">
					{{ storeName }}
				</span>
			</span>
			<div style="display:inline-block;white-space:no-wrap;">
				<span
					class="link-to-modal"
					v-if="!isSelectedForShipping && !product.isTire"
					@click="$emit('showChangeStore')"
				>
					Change Store
				</span>
				<span class="grey-text" v-if="!isSelectedForShipping && !product.isTire">
					to check availability nearby.
				</span>
			</div>
		</div>
		<div v-show="!!quantityExceptionMessage" class="user-hint">
			<span class="red-text" v-if="maxBuyableQty > 0">
				<i class="fa fa-exclamation-triangle"></i>
				{{ quantityExceptionMessage }}
			</span>
		</div>
		<div v-show="!!quantityMinIntervalMessage" class="user-hint">
			<span class="bopus-message">
				{{ quantityMinIntervalMessage }}
			</span>
		</div>
	</div>
</template>

<script>
import { getSpecialQuantityMessaging, validateQuantity } from 'JS/utilities/product/quantity';


export default {
	name: 'QuantityExceptionMessaging',
	computed: {
		quantity() {
			return this.$store.state.quantity;
		},
		product() {
			return this.$store.state.product;
		},
		maxBuyableQty() {
			return this.$store.getters.maxBuyableQty;
		},
		quantityExceedsStock() {
			return this.$store.getters.quantityExceedsStock;
		},
		productHasStock() {
			return this.$store.getters.productHasStock;
		},
		localStore() {
			return this.$store.state.localStore;
		},
		remainingSelectors() {
			return this.$store.getters.remainingSelectors;
		},
		storeName() {
			return this.isSelectedForShipping ? 'online' :
				this.localStore ? `at ${this.localStore.cityAlias}` : '';
		},
		isSelectedForShipping() {
			return this.$store.getters.isSelectedForShipping;
		},
		showOnlyAvailableMessage() {
			return this.quantityExceedsStock;
		},
		quantityExceptionMessage() {
			if (this.showOnlyAvailableMessage) return null;
			return validateQuantity(this.quantity, this.product) || null;
		},
		quantityMinIntervalMessage() {
			if (this.showOnlyAvailableMessage || this.quantityExceptionMessage)  {
				return null;
			}

			return getSpecialQuantityMessaging(this.product);
		},
	}
};
</script>

<style lang="less" scoped>
@import '../../../less/_mixins.less';
.bopus-message {
	color: #777777;
	font-weight: 500;
	font-size: 14px;
	margin: 15px 0 5px 0;
	text-align: center;
	line-height: 1.5em;
}

.user-hint {
	margin-bottom: 15px;
	text-align: center;
	line-height: 1.25em;
	.red-text {
		color: #B12F31;
		font-size: 14px;
	}

	.link-to-modal {
		color: #014A77;
		text-decoration: underline;
		cursor: pointer;
		font-size: 12px;
		white-space: nowrap;
	}

	.grey-text {
		font-size: 12px;
		color: #666666;
	}
}

.mobile-styles({
	.bopus-message {
		font-size: 12px;
		margin: 10px 0 0 0;
	}
});

@media screen and (max-width: @mobile-small) {
	.user-hint {
		.red-text {
			font-size: 12px;
		}
	}
}
</style>